import React from "react";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../../stores/actionsList';

import { checkTextTranslation, checkTranslation, imageAddress, pathMaker, phoneStandardView, priceStandardView, translate } from "../../../../utils/useful";
import ButtonAnimated from "../../../buttons/ButtonAnimated";
import HttpServices from "../../../../utils/Http.services";

class MainMessengerControl extends React.Component {

    state = {
        listSearch: '',
        filteredContacts: []

    }

    componentDidMount() {
        // this.setState({ contactsList: this.props.contactsList })
        this.fetchContacts()
    }


    fetchContacts = () => {
        let body = {}//this.props.variables
        this.setState({ isLoadingContacts: true })
        HttpServices.request('getMessengerApplets', body, (fetchResult, fetchError) => {

            console.log(fetchResult, fetchError)

            this.setState({ isLoadingContacts: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            // this.setState({ contactsList: fetchResult.info }, () => {
            // console.log('fetchContacts',this.state.contactsList)
            this.setState({ filteredContacts: fetchResult.info })
            // })
        })
    }


    render() {
        return (
            <div className="w-100 h-100 ">
                <div className="pb-1 px-2" style={{}}>
                    <div className="flexcb pt-3" style={{}}>
                        <div className='flexc' style={{}}>
                            <button className="br-30 flexcc p-2" onClick={() => { this.props.closeSidebar() }} style={{ display: this.props.isDesktop ? 'none' : 'flex', backgroundColor: '#eee', height: 25, width: 25 }} >
                                <img src={'/assets/icons/useful/angle-right.svg'} height="18px" className={this.props.language == 'fa' ? "" : " rotate-180"} />
                            </button>
                            <p className=" text-normal text-bold px-1">{translate("New chat")}</p>
                        </div>
                        {/* <div className="flexc mld-2">
                            <ButtonAnimated
                                iconwidth='24px'
                                onClick={() => this.props.changeStage('createGroup')}
                                title={translate('messenger.New group')}
                                icon='/assets/icons/plus-white.svg'
                                textColor={'#fff'}
                                // isLoading={this.props.isLoadingView}
                                bg={this.props.background ?? ' linear-gradient(90deg, #0085ff, #0085ff)'}
                                width={'100%'}
                            />
                        </div> */}
                        {/* <button className="flexcb px-1 px-2 py-2 mb-1 br-10" style={{ backgroundColor: "#0085ff" }} onClick={() => this.props.changeStage('createGroup')}>
                            <img width={20} src={'/assets/icons/messenger/newgroup.svg'} />
                            <p className="font-size-12 weight-500 mx-2" style={{ color: '#fff' }}>{translate('messenger.New Group')}</p>
                        </button> */}
                    </div>


                    {/* <div className=" mt-2">

                    {this.props.isApplet && (
                        <button className="flexc px-1 w-100 pb-2 pt-1 mb-1" style={{ borderBottom: "1px solid #f6f6f6" }} onClick={() => this.props.changeStage('createSupport')}>
                            <img src={'/assets/icons/applets/messenger/group.png'} height="20px" />
                            <p className="mx-2 text-small text-semibold" style={{ color: '#009aff' }}>New Support</p>
                        </button>
                    )}

                    <button className="flexc px-1 w-100 pb-2 pt-1 mb-1" style={{ borderBottom: "1px solid #f6f6f6" }}>
                        <img src={'/assets/icons/applets/messenger/createContact.png'} height="20px" />
                        <p className="mx-2 text-small text-semibold" style={{ color: '#0085ff' }}>New Contact</p>
                    </button>

                    <button className="flexc px-1 w-100 pb-2 pt-1 mb-1" style={{ borderBottom: "1px solid #f6f6f6" }}>
                        <img src={'/assets/icons/applets/messenger/broudcast.png'} height="20px" />
                        <p className="mx-2 text-small text-semibold" style={{ color: '#0085ff' }}>New Broadcast</p>
                    </button>


                </div> */}

                    <div className=" mt-2 w-100">
                        <div style={{ backgroundColor: '#f6f6f6', borderRadius: 10 }}>
                            <input className="py-2 px-2 w-100" placeholder={translate('messenger.Search')} value={this.props.listSearch} onChange={(e) => this.props.searchHub(e)} style={{ backgroundColor: 'transparent', border: 'none' }} />
                        </div>
                    </div>
                </div>
                <div className="scroll-no-scrollbar pb-3" style={{ height: 'calc(100% - 102.4px)' }}>

                    <div className="px-2">
                        <button className="flexc py-1 mt-2 px-1" onClick={() => this.props.changeStage('createGroup')}>
                            <img className="" src="/assets/icons/useful/group_add.svg" alt="" width={16} />
                            <p className="mld-2 text-semibold text-link">{translate("New group")}</p>
                        </button>

                        <button className="flexc py-1 px-1 mt-1" onClick={() => this.props.changeStage('createGroup')}>
                            <img className="" src="/assets/icons/useful/user-add.svg" alt="" width={16} />
                            <p className="mld-2 text-semibold text-link">{translate("New contact")}</p>
                        </button>


                        <p className="text-bold text-normal mt-2 mb-1">{translate("Contacts")}</p>
                    </div>


                    {Array.isArray(this.state.filteredContacts) && this.state.filteredContacts.map((item, index) => {
                        // console.log('item10', item)
                        return (
                            <div className=" w-100 bb-gray-messenger-list ">
                                <button className={" w-100 flexc py-2 br-4 px-2" + (item.frames.length == 1 ? " hover-gray2 " : '')} style={{ transition: 'all 0.5s', cursor: item.frames.length > 1 ? 'not-allowed' : null }} onClick={() => { if (item.frames.length == 1) { this.props.openOne(item, item.frames[0]) } }}>
                                    <div>
                                        <div className=" flexcc" style={{}}>
                                            <img src={imageAddress(item?.hub?.image, "profile", 'thumb')} style={{ width: 30, height: 30, borderRadius: 30, objectFit: 'cover' }} alt="" />
                                        </div>
                                    </div>
                                    <div className="px-2 w-100 text-start">
                                        <div className="flexcb w-100">
                                            <p className="mb-0 text-bold" style={{ fontSize: 13, color: '#202020' }}>{item.hub?.fullname}</p>
                                            {/* <p className="mb-0 text-semibold" style={{ fontSize: 13, color: '#202020' }}>{checkTranslation(item.hub?.fullname)}</p> */}

                                            {/* {this.props.messengers?.notifications[item?._id] != null && this.props.messengers?.notifications[item?._id] != 0 && (
                                            <div className='white flexcc mld-2' style={{ borderRadius: 20, minWidth: 20, height: 20, lineHeight: 1, backgroundColor: '#ee5050', right: 0 }}>
                                                <span className='text-smaller'>{this.props.messengers.notifications[item?._id]}</span>
                                            </div>
                                        )} */}
                                        </div>
                                        {/* <p className="" style={{ color: '#567', fontSize: 11 }}>{this.props.language == 'fa' ? item.hub?.username + '@' : '@' + item.hub?.username}</p> */}
                                        {/* <p className="" style={{ color: '#567', fontSize: 11 }}>{'@' + item.hub?.username}</p> */}
                                        {/* <p className="" style={{ color: '#567', fontSize: 11 }}>{checkTranslation(item.name)}</p> */}
                                        <p className="" style={{ color: '#567', fontSize: 11 }}>@{item.hub?.username}</p>


                                    </div>

                                </button>

                                {Array.isArray(item.frames) && item.frames.length > 1 && (
                                    <div className=" pt-0 pb-1 px-1">
                                        {item.frames.map((frame, index) => {
                                            return (
                                                <button onClick={() => { this.props.openOne(item, frame) }} className="w-100 text-start br-4 flexc hover-gray2 transition-all px-2 " style={{ paddingTop: 5, paddingBottom: 5 }}>

                                                    <div className=" flexcc mrd-1 position-relative" style={{}}>
                                                        <img src={imageAddress(frame?.image, "messenger", 'thumb')} style={{ width: 18, height: 18, borderRadius: 18, objectFit: 'cover' }} alt="" />
                                                        <div className="flexcc position-absolute" style={{ top: 10, left: 10 }}>
                                                            <img src={imageAddress(frame.applet?.image, "applet", 'thumb')} style={{ width: 10, height: 10, borderRadius: 10, objectFit: 'cover' }} alt="" />
                                                        </div>
                                                    </div>
                                                    <div className=" flex-1" style={{ minWidth: 0 }} >
                                                        <p className="font-size-13 mld-2  w-100" style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{checkTranslation(frame.name)} - {checkTranslation(frame.applet?.name)}</p>
                                                    </div>
                                                    {/* <p>{checkTranslation(frame.applet?.name)}</p> */}

                                                </button>
                                            )
                                        })}
                                    </div>
                                )}

                            </div>
                        )
                    })}
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => ({ settings: state.settings, user: state.user, messengers: state.messengers })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(MainMessengerControl);